import { ORDER_LIST_TABLE_FIELDS } from '@/utils/constants'

/**
 * 추후 기능 추가 및 기본 값 변경 시, 아래 storage key를 업데이트 해주세요.
 */
const STORAGE_KEY_ORDER_LIST_TABLE_FIELD = 'order_list_table_fields_v1'

const initOrderListTableFields = () => {
  const defaultFields = ORDER_LIST_TABLE_FIELDS.filter((x) => x.isDefault).map((x) => x.value)

  let cache

  try {
    cache = JSON.parse(localStorage.getItem(STORAGE_KEY_ORDER_LIST_TABLE_FIELD))
  } catch (error) {}

  return cache ?? defaultFields
}

const uiModule = {
  namespaced: true,
  state: {
    loadingCount: false,
    tableHeight: 350,
    inputHeight: 350,
    orderListTableFields: initOrderListTableFields(),
  },

  getters: {
    contentsLoading: (state) => state.loadingCount > 0,
    tableHeight: (state) => state.tableHeight,
    inputHeight: (state) => state.inputHeight,
    orderListTableFields: (state) => state.orderListTableFields,
  },

  mutations: {
    setContentsLoading(state, loading) {
      if (loading) {
        state.loadingCount++
      } else {
        state.loadingCount = Math.max(state.loadingCount - 1, 0)
      }
    },
    setTableHeight(state, height) {
      state.tableHeight = height
    },
    setInputHeight(state, height) {
      state.inputHeight = height
    },
    setOrderListTableFields(state, fields) {
      state.orderListTableFields = fields
    },
  },

  actions: {
    setOrderListTableFields({ commit }, fields) {
      commit('setOrderListTableFields', fields)

      localStorage.setItem(STORAGE_KEY_ORDER_LIST_TABLE_FIELD, JSON.stringify(fields))
    },
  },
}

export default uiModule
